import apiClient from './api';

// What a job post asks applicants for, checked against the user's profile
// before the cover letter is written. The letter then follows the result.
export default {
  // { available, subject_line, checklist: [...], gaps: [...] }. Each gap has
  // tap-to-answer `options`; withOptions: false skips building them (one AI call)
  // for views that only show the checklist.
  async check(jobId, { withOptions = true } = {}) {
    const body = { job_id: jobId };
    if (!withOptions) body.with_options = false;
    // The first check of a job reads the post and writes answer options (two AI
    // calls, ~10-15s); the client's 10s default dropped it, so no questions were
    // asked (Oct 23 real-app test).
    const response = await apiClient.post('/cover-letters/preflight/', body, { timeout: 60000 });
    return response.data;
  },

  // Saves one answer (or a skip) and returns the updated check.
  async answer(jobId, gapId, { answer = '', skipped = false } = {}) {
    const response = await apiClient.post('/cover-letters/preflight-answer/', {
      job_id: jobId,
      gap_id: gapId,
      answer,
      skipped,
    }, { timeout: 30000 });
    return response.data;
  },
};
